export default __webpack_public_path__ + "static/latitude-pay-video-b5b89b823d0d99d1c5f0d2f29f9fbf47.png";